<template>
    <div class="block-split__item block-split__item-sidebar col-auto">
        <div class="widget widget-filters widget-filters--offcanvas--mobile" data-collapse data-collapse-opened-class="filter--opened">
            <div class="widget__header widget-filters__header">
                <h4>Search Filters</h4>
            </div>

            <div class="widget-filters__item" v-if="customerIndicator == 'B'">
                <div class="filter filter--opened" data-collapse-item>                                                       
                    <div class="filter__body" data-collapse-content>
                        <div class="filter__container">
                            <div class="filter-vehicle">
                                <ul class="filter-vehicle__list">
                                    <li class="filter-vehicle__item ">
                                        <label class="filter-vehicle__item-label">
                                            <span class="filter-list__input input-radio">
                                                <span class="input-radio__body">
                                                    <!-- :checked="selections.Available == true" -->
                                                    <input class="input-radio__input" name="filter_stocks" type="radio" value="Y" v-model="selections.Available" @change="tick_filters">
                                                    <span class="input-radio__circle"></span>
                                                </span>
                                            </span>
                                            <span class="filter-vehicle__item-title font-on-hand">
                                                <strong>AVAILABLE</strong>
                                            </span>
                                            <span class="filter-vehicle__item-counter"></span>
                                        </label>
                                    </li>
                                    <li class="filter-vehicle__item ">
                                        <label class="filter-vehicle__item-label">
                                            <span class="filter-list__input input-radio">
                                                <span class="input-radio__body">
                                                    <input class="input-radio__input" name="filter_stocks" type="radio" value="N" v-model="selections.Available" @change="tick_filters">
                                                    <span class="input-radio__circle"></span>
                                                </span>
                                            </span>
                                            <span class="filter-vehicle__item-title">
                                                All Parts
                                            </span>
                                            <span class="filter-vehicle__item-counter"></span>
                                        </label>
                                    </li>
                                </ul>

                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            
            <div class="widget-filters__item" v-if="filter_ptypes.length > 0">
                <div data-collapse-item  :class="(open_ftypes === true) ? 'filter filter--opened' : 'filter' " >
                    <button type="button" class="filter__title" data-collapse-trigger @click="open_ftypes = !open_ftypes">
                        Part Types
                        <span class="filter__arrow"><svg width="12px" height="7px">
                                <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                            </svg></span>
                    </button>
                    <div class="filter__body" data-collapse-content>
                    <div class="filter__container">
                        <div class="filter-list">
                            <div class="filter-list__list">
                                <label class="filter-list__item"  v-for="(ptype, i) in filter_ptypes" :key="i">
                                    <span class="input-check filter-list__input">
                                        <span class="input-check__body">
                                            <!-- :checked="selections.PartTypes.find(p => p == ptype.val)"  -->
                                            <input class="input-check__input" type="checkbox" :value="ptype.val" v-model="selections.PartTypes" @change="tick_filters">
                                            <span class="input-check__box"></span>
                                            <span class="input-check__icon"><svg width="9px" height="7px">
                                                    <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                </svg>
                                            </span>
                                        </span>
                                    </span>
                                    <span class="filter-list__title text-uppercase">
                                        {{ ptype.val }}
                                    </span>
                                    <span class="filter-list__counter"> {{ ptype.count }}</span>
                                </label>

                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>

            <div class="widget-filters__item" v-if="filter_ptypes.length > 0">
                <div data-collapse-item :class="(open_fbrand === true) ? 'filter filter--opened' : 'filter' ">
                    <button type="button" class="filter__title" data-collapse-trigger @click="open_fbrand = !open_fbrand">
                        Brand
                        <span class="filter__arrow"><svg width="12px" height="7px">
                                <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                            </svg></span>
                    </button>
                    <div class="filter__body" data-collapse-content>
                    <div class="filter__container">
                        <div class="filter-list">
                            <div class="filter-list__list">
                                <label class="filter-list__item "  v-for="(brand, i) in filter_brands" :key="i">
                                    <span class="input-check filter-list__input ">
                                        <span class="input-check__body">
                                            <input class="input-check__input" type="checkbox" :value="brand.val.toUpperCase()" v-model="selections.Brands" @change="tick_filters">
                                            <span class="input-check__box"></span>
                                            <span class="input-check__icon"><svg width="9px" height="7px">
                                                    <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                </svg>
                                            </span>
                                        </span>
                                    </span>
                                    <span class="filter-list__title text-uppercase">
                                        {{ brand.val }}
                                    </span>
                                    <span class="filter-list__counter"> {{ brand.count }}</span>
                                </label> 
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>

            <div v-if="viewMore === true">
                <div class="widget-filters__item" v-for="(cfilter, indx) in __filters" :key="indx">
                    <div data-collapse-item :class="(cfilter.collapse === true) ? 'filter filter--opened' : 'filter' " >
                        <button type="button" class="filter__title" data-collapse-trigger @click="cfilter.collapse = !cfilter.collapse">
                            {{ cfilter.filter.replace(/_/g, " ") }}
                            <span class="filter__arrow">
                                <svg width="12px" height="7px">
                                    <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                                </svg>
                            </span>
                        </button>
                        <div class="filter__body" data-collapse-content>
                            <div class="filter__container">
                                <div class="filter-list">
                                    <div class="filter-list__list">
                                        <label class="filter-list__item" v-for="(cf, i) in cfilter.values.filter(f => f.val != '')" :key="i">
                                            <span class="input-check filter-list__input " v-if="cf.val != ''">
                                                <span class="input-check__body">
                                                    <input class="input-check__input"  type="checkbox"  :value="cf.val" v-model="selections[cfilter.filter]"
                                                    @change="tick_filters(cfilter.filter)" />
                                                    <span class="input-check__box"></span>
                                                    <span class="input-check__icon">
                                                        <svg width="9px" height="7px">
                                                            <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                        </svg>
                                                    </span>
                                                </span>
                                            </span>
                                            <span class="filter-list__title text-uppercase">
                                                {{ cf.val }}
                                            </span>
                                            <span class="filter-list__counter"> {{ cf.count }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="widget-filters__actions d-flex">
                <button class="btn btn-primary btn-sm" @click="viewMore = !viewMore" >{{btnFilterCaption}}</button>
                <button class="btn btn-primary btn-sm" @click="search" v-if="btnSearchShow">Search</button>
                <button class="btn btn-secondary btn-sm" @click="reset">Reset</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import SolrHelper from '../../../mixins/solr_helper';

export default {
    props: {
        facet_filters: {
            type: Object,
        },
        keyword: {
            type: String,
        },
    },

    watch:{
        keyword() {
            // console.log('keyword new val = ' + newVal);
            // this.resetValue.Available = this.selections.Available;
            // this.selections = this.resetValue;
            // this.$store.dispatch('setSolr_faceted_filter', this.selections);
        },

        viewMore(newVal){
            if(newVal == true){
                this.btnFilterCaption = 'Hide Filter';
            }else{
                this.btnFilterCaption = 'More Filter';
            }
        }
    },

    data() {
        return {
            hideFilter: true,
            // filter toggles
            open_fcolor: true,
            open_fbrand: true,
            open_fweight: true,
            open_fprice: true,
            open_ftypes: true,

            filter_ptypes: [],
            filter_colors: [],
            filter_brands: [],
            filter_weight: [],
            filter_prices: [],
            btnSearchShow: true,

            selections: {
                Available: "Y",
                // Stocks: false,
                PartTypes: [],
                Brands: [],
            },

            resetValue: {
                Available: "Y",
                // Stocks: false,
                PartTypes: [],
                Brands: [],
            },

            viewMore: false,
            filter_more : [],
            btnFilterCaption : 'More Filter',
        }
    },

    computed: {
        ...mapGetters(['customerIndicator']),

        ...mapGetters('product', ['filter_attr']),

        __filters() {
            return this.filter_more;
        },
    },

    mixins: [SolrHelper],

    beforeCreate(){
        // console.log('filter beforeCreate');
    },

    methods: {
        tick_filters(){
            // console.log(this.selections);
            this.$emit('filter_changed', this.selections);
            this.$store.dispatch('setSolr_faceted_filter', this.selections);
        },

        solr_search(filters = null) {

            // const ffields = ['IGDESC', 'MCNAME', 'Color', 'Size', 'Material'];
            const ffields = ['IGDESC', 'MCNAME'];

            this.filter_attr.forEach(f => {
                ffields.push(f);
            });

            this.$emit('clear_messages');
            this.parts = [];
            this.isloading = true;
            let keyword = this.keyword;
            // let filter_uri = this.mx_multi_facet_filter(filters);
            let json_facet_uri = this.mx_json_facet(ffields);
            console.log( 'json_facet_uri = ' + json_facet_uri);

            let filter_uri = '';
            if(filters != null){
                // console.log('filter is not nULL');
                // filter_uri = this.mx_faceted_filter(filters);
                filter_uri = this.mx_multi_facet_filter(filters);
                // filter_uri = this.mx_get_filter();
                if(this.$store.getters.customerIndicator == 'C'){
                    filter_uri += '&fq=Stocks:[1 TO *]';
                }
            }else{
                // console.log('filter is nULL');
                // defaults filter search
                // filter_uri = '&fq=Stocks:[1 TO *]';
                // console.log(this.$store.getters.solr_faceted_filter);
                filter_uri += this.mx_multi_facet_filter(this.$store.getters.solr_faceted_filter);
            }

            if(this.keyword == null){
                keyword = '*';
            }

            filter_uri += json_facet_uri;

            // console.log( 'filter_uri' + filter_uri); 
            
            // const solr_core_admin = this.$store.getters.storefrontAttributes.find(attribute => attribute.type === 'SCA');
            const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
            let uri = solr_host + '/select?q.op=AND&q=Item_Desc%3A*'+keyword+'*%20OR%20Item%3A*'+keyword+'*&facet.field=IGDESC&facet.field=MCNAME&facet=true&facet.field=Color&f.B2C_price.facet.range.start=0&f.B2C_price.facet.range.end=1000&f.B2C_price.facet.range.gap=100&facet.range=B2C_price&f.Weight.facet.range.start=0&f.Weight.facet.range.end=100&f.Weight.facet.range.gap=10&facet.range=Weight&group=true&group.field=Item&group.facet=true&group.format=simple&group.ngroups=true';
            uri += filter_uri;
            axios.get(uri,{
                auth: {
                    username: this.$store.getters.solr_username,
                    password: this.$store.getters.solr_password
                }
            })
            .then((response) => {
                // console.log(response);
                // const MPARTS = response.data.response.docs;
                this.facets = response.data.facets;
                this.rebuildFilter(this.facets);

                // console.log(this.facets);
                // console.log(this.parts);
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        rebuildFilter(facet_filters) {
            // console.table(facet_filters);
            this.filter_colors = [];
            this.filter_brands = [];
            this.filter_prices = [];
            this.filter_weight = [];
            this.filter_ptypes = [];
            this.filter_more   = [];

            var i,j;

            for(const filter in facet_filters){
                const fvalues = [];
                if(filter != 'MCNAME' && filter != 'IGDESC' && filter != 'count' ){
                    if(this.selections[filter] == undefined){
                        this.selections[filter] = [];
                    }
                    for (i = 0,j = facet_filters[filter].buckets.length; i < j; i++) {
                        if(facet_filters[filter].buckets[i].val == '')
                            continue;
                        const buckets = facet_filters[filter].buckets[i];
                        fvalues.push({
                            val : buckets.val,
                            count : buckets.count,
                            cval : this.convert_num(buckets.val)
                        });
                    }
                    fvalues.sort((a,b) => (a['cval'] > b['cval']) ? 1 : ((b['cval'] > a['cval']) ? -1 : 0));
                    console.table(fvalues);
                    if(fvalues.length > 0){
                        this.filter_more.push({
                            filter: filter,
                            collapse: true,
                            values: fvalues
                        });
                    }
                }
            }

            for (i = 0,j = facet_filters.MCNAME.buckets.length; i < j; i++) {
                this.filter_brands.push(facet_filters.MCNAME.buckets[i]);
            }
            this.filter_brands.sort((a,b) => (a['val'] > b['val']) ? 1 : ((b['val'] > a['val']) ? -1 : 0));

            for (i = 0,j = facet_filters.IGDESC.buckets.length; i < j; i++) {
                this.filter_ptypes.push(facet_filters.IGDESC.buckets[i]);
            }
            this.filter_ptypes.sort((a,b) => (a['val'] > b['val']) ? 1 : ((b['val'] > a['val']) ? -1 : 0));
        },

        removeFilter(f) {
            switch(f){
                case 'PartTypes':
                    this.selections.PartTypes = [];
                    break;
                case 'Brands':
                    this.selections.Brands = [];
                    break;
                case 'Colors':
                    this.selections.Colors = [];
                    break;
                case 'Weights':
                    this.selections.Weights = [];
                    break;
                case 'Prices':
                    this.selections.Prices = [];
                    break;
                case 'Available':
                    this.selections.Available = false;
                    break;
                case 'Stocks':
                    this.selections.Stocks = false;
                    break;
                default:
                    this.selections =  {
                        Available: "Y",
                        Stocks: false,
                        PartTypes: [],
                        Brands: [],
                    };

                    break;
            }
            // console.log(this.selections);
            this.$emit('filter_changed', this.selections);
        },

        reset(){
            this.selections =  this.resetValue;
            this.$store.dispatch('setSolr_faceted_filter', this.selections);
            this.$emit('filter_changed', this.selections);

            this.$router.push('/order-parts');
        },

        search() {
            let hasChecked = false;
            for(const a in this.selections){
                if(this.selections[a].length > 0){
                    hasChecked = true;
                    break;
                }
            }

            if (hasChecked == true){
                this.$store.dispatch('setSolr_faceted_filter', this.selections);
                this.$router.push('/keyword-search-results?search=*');
            }
        },

        fetch_curr_filter(){
            return this.selections;
        },

        
        convert_num(val) {
            const firstdig = val[0];
            if (isNaN(firstdig)){
                return val;
            }

            const digs = val.split("-");
            let cval = 0;
            digs.forEach(d => {
                cval += parseFloat(this.fractionToDecimal(d));
            });

            return cval;
        },

        // convert fraction to decimal
        fractionToDecimal(f) {
            return f.split('/').reduce((n, d, i) => n / (i ? d : 1));
        }
    },

    updated() {
        console.log('updated - search filter');
        // if(this.facet_filters){
        //     this.rebuildFilter();
        // }
    },

    created() {
        // console.log('SearchResultsFilter created');
        // this.solr_search(null);
        // console.log('current route = ' + this.$router.currentRoute._value.name);

        // clear the faceted filter selections on load of Order Parts
        if(this.$router.currentRoute._value.name == 'OrderParts'){
            this.selections = this.resetValue;
            this.btnSearchShow = true;
        }else{
            this.btnSearchShow = false;
        }
    },

    mounted() {
        // console.log('mounted - ' + this.$router.currentRoute._value.name);

        // get the faceted filter from the vuex
        if(this.$store.getters.solr_faceted_filter != null && this.$router.currentRoute._value.name == 'KeywordSearchResults'){
            if(this.keyword == '*'){
                this.selections = this.$store.getters.solr_faceted_filter;
            }else{
                this.selections = this.resetValue;
            }
            
            this.$emit('filter_changed', this.selections);
        }else{
            this.$emit('filter_changed', this.selections);
        }
    }
}
</script>

<style scoped>
    .text-uppercase {
        text-transform: uppercase;
    }

    .text-capital {
        text-transform: capitalize;
    }
    .filter-list__list{
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>